export default __webpack_public_path__ + "static/media/gg.012f962a.jpg";